export enum OutlookAddInMessageType {
  LOGIN = 'LOGIN',
}

export interface OutlookAddInMessagePayloadMap {
  [OutlookAddInMessageType.LOGIN]: {
    authCode: string;
  };
}

export interface OutlookAddInMessage<T extends OutlookAddInMessageType> {
  type: T;
  payload: OutlookAddInMessagePayloadMap[T];
}
